import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarketplaceComponent } from './marketplace.component';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { ViewMarketplaceComponent } from './view-marketplace/view-marketplace.component';
import { BookMarketplaceServicesComponent } from './book-marketplace-services/book-marketplace-services.component';
import { NgOtpInputModule } from 'ng-otp-input';

const routes: Routes = [
  {
    path: '',
    component: MarketplaceComponent
  },
  {
    path: 'view-marketplace',
    component: ViewMarketplaceComponent
  },
  {
    path: 'view-marketplace/:id',
    component: ViewMarketplaceComponent
  }
];

@NgModule({
  declarations: [MarketplaceComponent, BookMarketplaceServicesComponent],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(routes),
    NgOtpInputModule
  ],
  entryComponents: [BookMarketplaceServicesComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})

export class MarketplaceModule { }
